// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Ambiente dev (bme-dev-app, acessado pela VPN): APIs em *.dev.bkme-api.com
// e fronts em *.dev.benqme.com.br, via Traefik com HTTPS.
export const environment = {
    production: false,
    environment: "development",
    vars: {
        apis: {
            crm: "https://api-bankme.dev.bkme-api.com",
            oracle: "https://api-oracle.dev.bkme-api.com",
            credito: "https://credito.staging.bankme.tech",
            bff: "https://api-oracle.dev.bkme-api.com/bff-front-bankme",
            monitor: "https://worker-integrations.dev.bkme-api.com/",
        },
        datadog: {
            clientToken: "pube0b4d3eb039cc3f49a8e6aab60d17f9e",
            applicationId: "e2a61d17-127e-4647-a485-d65d5eacfc5e",
        },
        amplitude: {
            apiKey: "b14ca311720108b69a988f69c0045160",
        },
        next: "https://app.dev.benqme.com.br",
        growthbook: {
            clientKey: "sdk-LAk6KJwO1xZsGlu3",
            decryptionKey: "bankme_tech",
        },
        email: "b543abf53743aecc4e0a5ae470286291",
        whitelist: ["https://viacep.com.br"],
        hj: "2717721",
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import "zone.js/plugins/zone-error"; // Included with Angular CLI.
